import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ImmunizationPatient, ImmunizationRecord } from "../../models/Interfaces";
import EventCard from "../../components/EventCard";

interface EventLocationState {
  record: ImmunizationRecord;
  patient: ImmunizationPatient;
}

export default function Events() {
  const { state } = useLocation();
  const { record, patient } = (state as EventLocationState) || {};

  return (
    <div className="section">
      <p className="is-size-3 has-text-dark">
        {record.vaccineType +
          " Doses for " +
          `${patient?.firstName || ""} ${patient?.lastName || ""}`}
      </p>
      <br />
      <ul>
        {record?.events?.map((e, index) => (
          <li className="mb-4" key={index}>
            <EventCard index={index} event={e} />
          </li>
        ))}
      </ul>
    </div>
  );
}
